export const STATE_PROP_NAME = 'myEntityStar'
export const CONFIRMATION_STATUSES = {
  UNCONFIRMED: 'unconfirmed',
  CONFIRMING: 'confirming',
  CONFIRMED: 'confirmed',
}
